module.exports = __webpack_public_path__ + "static/media/pic7.b6d7cbf0.jpg";